/*
  TREASURE BOX - 재입고 요청(Restock Request) 모달 로직
  ------------------------------------------------------------
  ".tb-restock-request-btn" 클래스를 가진 버튼(품절 상품 상세페이지)을
  클릭하면 전역 모달(#tb-restock-request-modal)을 열고, 버튼의 data-*
  속성에서 상품 정보(상품ID, 상품명, 상품URL)를 읽어와 모달에 채워 넣습니다.

  고객이 이메일을 입력하고 제출하면:
    POST {API_BASE}/api/restock-requests
  negotiation-api(Cloudflare Worker)가 D1에 저장하고, Resend API로
  사장님(kermu@naver.com)에게 알림 이메일을 발송합니다.

  tb-price-offer.js와 동일한 전역 모달 열기/닫기 패턴을 따르되, 캡차
  (Turnstile)는 사용하지 않습니다(이메일 1건 남기는 가벼운 액션이며,
  서버에서 IP 기준 요청 빈도 제한으로 자동화 남용을 방지합니다).
*/
document.addEventListener('DOMContentLoaded', function () {
  var overlay = document.getElementById('tb-restock-request-overlay');
  var modal = document.getElementById('tb-restock-request-modal');
  if (!modal || !overlay) return;

  var API_BASE = modal.getAttribute('data-api-base') || '';

  var closeBtn = document.getElementById('tb-restock-request-close');
  var cancelBtn = document.getElementById('tb-restock-request-cancel');
  var productNameEl = document.getElementById('tb-restock-request-product-name');

  var form = document.getElementById('TbRestockRequestForm');
  var emailInput = document.getElementById('TbRestockRequestForm-email');
  var submitBtn = document.getElementById('tb-restock-request-submit-btn');
  var submitErrorBox = document.getElementById('tb-restock-request-submit-error');
  var submitErrorText = document.getElementById('tb-restock-request-submit-error-text');

  var resultWrap = document.getElementById('tb-restock-request-result');
  var resultSuccessBox = document.getElementById('tb-restock-request-success');
  var resultAlreadyBox = document.getElementById('tb-restock-request-already');
  var resultErrorBox = document.getElementById('tb-restock-request-error');
  var resultErrorText = document.getElementById('tb-restock-request-error-text');

  var closeOkBtn = document.getElementById('tb-restock-request-close-ok');
  var closeAlreadyBtn = document.getElementById('tb-restock-request-close-already');
  var retryBtn = document.getElementById('tb-restock-request-retry-btn');

  var strings = window.tbRestockRequestStrings || {};

  var currentProduct = { productId: '', title: '', url: '' };

  function setLoading(btn, loading) {
    if (!btn) return;
    var label = btn.querySelector('span:not(.tb-price-offer-spinner)');
    var spinner = btn.querySelector('.tb-price-offer-spinner');
    btn.disabled = !!loading;
    if (spinner) spinner.hidden = !loading;
    if (label) label.style.visibility = loading ? 'hidden' : 'visible';
  }

  function showStep1() {
    form.hidden = false;
    resultWrap.hidden = true;
    [resultSuccessBox, resultAlreadyBox, resultErrorBox].forEach(function (box) {
      if (box) box.hidden = true;
    });
    if (submitErrorBox) submitErrorBox.hidden = true;
  }

  function showResultBox(box) {
    form.hidden = true;
    resultWrap.hidden = false;
    [resultSuccessBox, resultAlreadyBox, resultErrorBox].forEach(function (b) {
      if (b) b.hidden = b !== box;
    });
  }

  function resetModalState() {
    showStep1();
  }

  function openModal(trigger) {
    currentProduct.productId = trigger.getAttribute('data-tb-product-id') || '';
    currentProduct.title = trigger.getAttribute('data-tb-product-title') || '';
    currentProduct.url = trigger.getAttribute('data-tb-product-url') || '';

    if (productNameEl) productNameEl.textContent = currentProduct.title;

    resetModalState();

    overlay.hidden = false;
    modal.hidden = false;
    document.body.style.overflow = 'hidden';

    setTimeout(function () {
      if (emailInput) emailInput.focus();
    }, 50);
  }

  function closeModal() {
    overlay.hidden = true;
    modal.hidden = true;
    document.body.style.overflow = '';
  }

  document.querySelectorAll('.tb-restock-request-btn').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      openModal(btn);
    });
  });

  if (closeBtn) closeBtn.addEventListener('click', closeModal);
  if (cancelBtn) cancelBtn.addEventListener('click', closeModal);
  if (closeOkBtn) closeOkBtn.addEventListener('click', closeModal);
  if (closeAlreadyBtn) closeAlreadyBtn.addEventListener('click', closeModal);
  overlay.addEventListener('click', closeModal);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !modal.hidden) closeModal();
  });

  function isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  function showSubmitError(message) {
    if (submitErrorText) submitErrorText.textContent = message;
    if (submitErrorBox) submitErrorBox.hidden = false;
  }

  function doSubmitRestockRequest(email) {
    setLoading(submitBtn, true);
    if (submitErrorBox) submitErrorBox.hidden = true;

    fetch(API_BASE + '/api/restock-requests', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        shopify_product_id: currentProduct.productId,
        product_title: currentProduct.title,
        product_url: currentProduct.url,
        email: email,
      }),
    })
      .then(function (resp) {
        return resp.json().then(function (data) {
          return { status: resp.status, data: data };
        });
      })
      .then(function (result) {
        setLoading(submitBtn, false);
        var status = result.status;
        var data = result.data || {};

        if (status === 429) {
          showSubmitError(
            data.message || strings.genericErrorMessage || '요청이 너무 많습니다. 잠시 후 다시 시도해 주세요.'
          );
          return;
        }
        if (status === 400) {
          if (data.error === 'invalid_email') {
            showSubmitError(strings.invalidEmailMessage || '올바른 이메일 주소를 입력해 주세요.');
          } else {
            showSubmitError(strings.genericErrorMessage || '처리 중 오류가 발생했습니다. 잠시 후 다시 시도해 주세요.');
          }
          return;
        }
        if (!resp_ok(status) || !data.ok) {
          if (resultErrorText) {
            resultErrorText.textContent = strings.genericErrorMessage || '처리 중 오류가 발생했습니다. 잠시 후 다시 시도해 주세요.';
          }
          showResultBox(resultErrorBox);
          return;
        }

        if (data.already_requested) {
          showResultBox(resultAlreadyBox);
        } else {
          showResultBox(resultSuccessBox);
        }
      })
      .catch(function () {
        setLoading(submitBtn, false);
        if (resultErrorText) {
          resultErrorText.textContent = strings.networkErrorMessage || '네트워크 오류가 발생했습니다. 잠시 후 다시 시도해 주세요.';
        }
        showResultBox(resultErrorBox);
      });
  }

  // fetch Response.ok는 status 범위(200-299)만 체크하므로, status 값만 넘겨받는
  // 이 함수 안에서 동일한 로직을 재현한다(이미 소비된 Response 객체 대신 사용).
  function resp_ok(status) {
    return status >= 200 && status < 300;
  }

  if (retryBtn) {
    retryBtn.addEventListener('click', function () {
      showStep1();
    });
  }

  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = (emailInput && emailInput.value || '').trim();
      if (!isValidEmail(email)) {
        showSubmitError(strings.invalidEmailMessage || '올바른 이메일 주소를 입력해 주세요.');
        return;
      }
      doSubmitRestockRequest(email);
    });
  }
});
